export default __webpack_public_path__ + "static/media/arihant_logo.bd6c233c.png";